export * from '@primeuix/themes/lara/colorpicker';
export { default } from '@primeuix/themes/lara/colorpicker';
